<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="2">
                    <h2 >Pay Buttons </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>
                            
                    <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                        <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                            <iframe class="i-frame" src="https://www.youtube.com/embed/bL69f97X_e8?si=RpuULWFNv751Rhi9"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen></iframe>
                        </div>
                    </div>
           

                <div class="col-md-12" (mouseover)="showpayment(true,'2')"
                (mouseout)="showpayment(false,'2')" id="2">

                    <label for="" class="mt-2" >The Pay Button is a fundamental
                        feature provided by
                        PayG
                        that
                        allows businesses to accept online payments securely and conveniently. It
                        simplifies
                        the payment process for both merchants and customers by providing a quick
                        and
                        straightforward way to initiate transactions. The pay button likely refers
                        to a
                        specific button or element provided by PayG's payment processing service.
                        This
                        button can be integrated into your website or app to enable customers to
                        initiate
                        payments securely</label>
                    <label for="" class="mt-3" >When a customer clicks on the "pay
                        button," it
                        typically
                        triggers the payment process, allowing the customer to enter their payment
                        details
                        and complete the transaction. PayG provides merchants with the necessary
                        tools
                        and
                        infrastructure, including the "pay button," to facilitate online payments
                        and
                        ensure
                        the security and efficiency of the transaction. </label>
                   
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="101"> <h2> Workflow
                 </h2>
                
                <div class="col-md-12 mt-3">
                    <img src="./assets/GIF/Creating Pay Button.gif" width="95%" height="95%"
                 alt="" style="border-radius: 10px;">
                 </div>
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="3">
                    <h2 >Key Benefits of Our Pay Buttons: </h2>

                    <ol >
                        <li class="mt-3"><b>Fast and Effortless Payments:</b> With our Pay Button,
                            your
                            customers
                            can complete their payments in just a few clicks, reducing checkout
                            times
                            and
                            enhancing their overall shopping experience. </li>

                        <li class="mt-3">

                            <b>Secure Transactions:</b> Your security is our top priority. The Pay
                            Button
                            ensures
                            that all transactions are protected by the highest level of encryption
                            and
                            security measures.
                        </li>

                        <li class="mt-3">

                            <b>Mobile Responsive:</b> Our Pay Button is designed to work flawlessly
                            on all
                            devices,
                            ensuring a smooth payment experience.
                        </li>

                        <li class="mt-3">

                            <b>Multiple Payment Options:</b> Choose from a wide range of payment
                            methods,
                            including
                            credit/debit cards, net banking, UPI, mobile wallets, and more.
                        </li>

                        <li class="mt-3">

                            <b>One-Click Payments:</b> For returning customers, our Pay Button
                            offers a
                            convenient
                            one-click payment option, saving you time and effort during subsequent
                            transactions.
                        </li>

                        <li class="mt-3">
                            <b>Easy Refunds and Disputes:</b> In the unlikely event of a refund or
                            dispute,
                            our
                            Pay
                            Button streamlines the process, ensuring a hassle-free resolution.
                        </li>


                    </ol>

                   
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="4">
                    <h2 >
                        This is how you can create your own customized pay button in PayG:
                    </h2>
                  
                    <ul>
                        <li class="mt-3" ><b>Sign into your Account: </b>&nbsp;If you
                            haven't
                            already,
                            sign
                            up for an account with PayG. It's quick and easy! </li>

                        <li class="mt-3" ><b>Access Your Dashboard : </b>&nbsp;Once
                            you're logged in,
                            navigate to your account dashboard, where you'll find a “Create button”,
                            by
                            clicking on that button you’ll find the "Pay Button" section. </li>


                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/button1.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <li class="mt-3" >
                            You can select any of the four pay buttons given “Pay Now”, “Buy Now”,
                            “Donate”,
                            and “Add to cart”.
                        </li>
                        
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button2.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <li class="mt-3" >
                            You can modify your pay button and obtain a preview of the button by
                            choosing one of the available themes after choosing the pay button.
                        </li>
                       
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button3.png" width="100%" height="100%" alt="">
                            </div>
                        </div>


                        <li class="mt-3" >
                            After creating the button, click on “Assignment” From here you can copy
                            the
                            code and paste it into an HTML format and then embed it wherever you
                            would
                            like to in your official webpage.
                        </li>
                      
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button 4.png" width="100%" height="100%" alt="">
                            </div>

                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button 5.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <li >
                            Merchants can check the transaction history for all four buttons done by
                            the
                            customers
                        </li>

                    </ul>
                </div>
                <div class="col-md-12">
                    <h2 class="mt-4" (mouseover)="showpayment(true,'5')"
                        (mouseout)="showpayment(false,'5')" id="5" >
                        The following description of the buttons can assist you in choosing the
                        right
                        type:
                    </h2>
                   
                    <label class="mt-3" ><b> "Buy Now” button: </b>&nbsp;The "Buy
                        Now" button can be
                        used
                        for single-item purchases. When a customer clicks on this button, they are
                        taken
                        directly to the checkout page, where they can complete the purchase for the
                        specific product or service they have selected. This button is ideal for
                        situations where the customer has already made up their mind and wants a
                        quick
                        and streamlined purchasing process.

                    </label>
                    <label class="mt-3" ><b> "Pay Now" button:</b>&nbsp;The "Pay Now"
                        button can be
                        used
                        for situations where the customer has already added items to their shopping
                        cart
                        and wants to proceed directly to payment without going through the
                        traditional
                        checkout process. It is commonly seen in one-click payment options or on
                        payment
                        request pages where the total amount is displayed, and the customer can
                        complete
                        the payment by clicking the "Pay Now" button.

                    </label>

                    <label class="mt-3" ><b> "Donate" Button: </b>&nbsp;The "Donate"
                        button can be
                        used
                        on websites or platforms where organizations or individuals seek donations
                        for
                        charitable causes, non-profit activities, or fundraising purposes. When
                        users
                        click on the "Donate" button, they are usually directed to a payment page
                        where
                        they can choose the donation amount and complete the transaction.

                    </label>

                    <label class="mt-3" ><b> "Add to Cart" Button: </b>&nbsp;The "Add
                        to Cart" button
                        can
                        be used by e-commerce websites to allow their customers to add items they
                        wish
                        to purchase to their virtual shopping cart. This enables customers to
                        continue
                        shopping and adding more items before proceeding to the checkout page to
                        finalize their purchase.



                    </label>
                   
                </div>
            </div>
        </div>
   </div>
    <div class="col-md-4 hide-tbl">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
                   
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >Introduction to Pay Buttons </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#101">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/workflow.svg" class="tab-icon intro"
                                    alt="">
                                </div>
                            <div class="col-md-10 mt-1" >
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='1'}" (click)="color('1')"
                                    >
                                    Workflow</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >
                                    Benefits of Pay Buttons </span>
                                
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >Creating
                                    Pay Buttons </span>
                           
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >Types of
                                    Pay Buttons </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/g-store']"> <button class="btn btn-color" (click)="menues('G-Store')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;G-Store
                </button></a>   
               
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/payment-qr']"> <button class="btn btn-color" (click)="menues('Payment QR')" >Payment
                    QR
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            
            </div>
        </div>
    </div>
    </div>